export default "../../src/img/patterns/c1-150x150.jpeg";